import type { MRRPState } from '../types/mrrp.types';

export const initialState: MRRPState = {
  newRequestFormOptions: {
    purposeOptions: [],
    reportTypeOptions: [],
  },
  newRequestFormValues: {
    collectionValues: {
      choice: undefined,
      deliveryAdd: {
        block: undefined,
        floor: undefined,
        postal: undefined,
        street: undefined,
      },
      diffAdd: {
        block: undefined,
        floor: undefined,
        postal: undefined,
        street: undefined,
      },
      isDiffAdd: false,
    },
    institute: undefined,
    particularsValues: undefined,
    reportDetailsValue: {
      admissionDate: '',
      clinicalDepartment: undefined,
      description: undefined,
      fee: undefined,
      hideDeliveryMode: false,
      isAttachmentMandatory: false,
      purpose: undefined,
      reportType: undefined,
      supportingDocument: undefined,
      visitType: undefined,
    },
  },
  payment: {
    paymentToken: undefined,
    referenceNumber: undefined,
  },
  viewRequestedInstitute: undefined,
};
